import domContentLoaded from 'dom-content-loaded';

export default () => {
	domContentLoaded(() => {
		const triggers = document.querySelectorAll('[data-has-child="true"]');
		for (let index = 0; index < triggers.length; index += 1) {
			const trigger = triggers[index];
			trigger.addEventListener('mouseover', () => {
				trigger.classList.remove('is_off');
				trigger.classList.add('is_on');
				trigger.querySelector('.bl_headerNavChild').classList.remove('is_off');
				trigger.querySelector('.bl_headerNavChild').classList.add('is_on');
			}, false);
			trigger.addEventListener('mouseleave', () => {
				trigger.classList.remove('is_on');
				trigger.classList.add('is_off');
				trigger.querySelector('.bl_headerNavChild').classList.remove('is_on');
				trigger.querySelector('.bl_headerNavChild').classList.add('is_off');
			}, false);
		}
	});
};
